import { render, staticRenderFns } from "./CeldaNumero.vue?vue&type=template&id=6b414efc&scoped=true&"
import script from "./CeldaNumero.vue?vue&type=script&lang=js&"
export * from "./CeldaNumero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b414efc",
  null
  
)

export default component.exports